import { Checkbox as MuiCheckbox, FormControlLabel } from "@mui/material";
import {
  Controller,
  FieldPath,
  FieldValues,
  get,
  useFormContext,
} from "react-hook-form";
import { CheckboxContainer } from "../../atoms/CheckboxControlLabel";
import { StyledErrorText } from "../../atoms/StyledErrorText";
import { getErrorMessage } from "../fieldTypes";

interface CheckboxProps<FormValues extends FieldValues = FieldValues> {
  label: string;
  name: FieldPath<FormValues>;
  disabled?: boolean;
}

const Checkbox = <FormValues extends FieldValues = FieldValues>({
  label,
  name,
  disabled = false,
}: CheckboxProps<FormValues>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<FormValues>();
  const error = get(errors, name) as unknown;
  const errorMsg = getErrorMessage(error);

  return (
    <CheckboxContainer>
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => (
          <FormControlLabel
            label={label}
            labelPlacement="end"
            disabled={disabled}
            control={
              <MuiCheckbox
                color={!error ? "primary" : "error"}
                checked={Boolean(value)}
                onChange={onChange}
              />
            }
          />
        )}
      />
      <StyledErrorText error={!!error}>{errorMsg}</StyledErrorText>
    </CheckboxContainer>
  );
};

export { Checkbox };
